import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { createSleep } from '../thunk';

import type { WakeupInputType } from '@/domain/sleep/component/WakeupFormInput';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

import DialogTitle from '@/components/DialogTitle';
import WakeupFormInput from '@/domain/sleep/component/WakeupFormInput';
import { MeasureDateTime } from '@/domain/sleep/service/entity/valueObjects/measureDateTime';
import { parseTimeByCurrentDate } from '@/utils/date';

/** プロパティ */
export type AddWakeupInput = {
  /** 開くか */
  isOpen: boolean,
  /** 閉じる */
  close: () => void,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
  /** 日付 */
  date?: Date,
};

const AddWakeup: React.FC<AddWakeupInput> = ({
  isOpen,
  close,
  user,
  child,
  facilityList,
  date,
}) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<WakeupInputType>({
    defaultValues: {
      measureDateTime: MeasureDateTime.toStringTime(new Date(), false),
    },
  });
  const onSubmit = (input: WakeupInputType) => {
    const username = user.name;
    const datetime = parseTimeByCurrentDate(input.measureDateTime, date);
    dispatch(createSleep({
      data: {
        data: {
          isSleepTime: false,
          measurerId: username,
          measurerType: 'app',
          measureDateTime: datetime.toJSON(),
          parentId: username,
          childId: child.childId,
        },
        pub: {
          sendId: `${child.parentId}_${child.childId}`,
          replyId: username,
          data: {},
        },
      },
      facilityIds: facilityList.map((v) => v.data.facilityId),
    }));
    close();
  };
  return (
    <Dialog
      open={isOpen}
      onClose={() => close()}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ minWidth: '300px' }}
      >
        <DialogTitle title="起床時間の登録" />
        <DialogContent>
          <WakeupFormInput
            control={control}
            errors={errors}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            type="submit"
            color="primary"
          >
            登録する
          </Button>
          <Button
            variant="contained"
            onClick={() => close()}
            color="primary"
          >
            閉じる
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddWakeup;
